import { render, staticRenderFns } from "./carrier-sel-page.vue?vue&type=template&id=0f926ac0&scoped=true"
import script from "./carrier-sel-page.vue?vue&type=script&lang=js"
export * from "./carrier-sel-page.vue?vue&type=script&lang=js"
import style0 from "./carrier-sel-page.vue?vue&type=style&index=0&id=0f926ac0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f926ac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f926ac0')) {
      api.createRecord('0f926ac0', component.options)
    } else {
      api.reload('0f926ac0', component.options)
    }
    module.hot.accept("./carrier-sel-page.vue?vue&type=template&id=0f926ac0&scoped=true", function () {
      api.rerender('0f926ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/carrier-sel-page.vue"
export default component.exports